// extracted by mini-css-extract-plugin
export default {"wrap":"CustomScroll_wrap__5emPo","content":"CustomScroll_content__DnG9h","track":"CustomScroll_track__dEQtj","thumb":"CustomScroll_thumb__5l39D"};